import AbstractRequestTask from './AbstractRequestTask';

class PaywayDataTask extends AbstractRequestTask {
  constructor(config) {
    super();
    this.config = config;
  }

  getUrl() {
    const domain = this.config.url_dominio_microfwk;

    return `${domain}/services/payway/data`;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      const newData = super.parseErrors(data);
      return this.reject(newData, b);
    }
    this.resolve(data);
  }
}

export default PaywayDataTask;
